import { checkboxClasses, radioClasses, type Theme, toggleButtonClasses } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const ToggleButtonStyle: StyleExtend<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '.25rem',
  textAlign: 'start',
  alignItems: 'start',
  minHeight: '60px',
  padding: '.75rem',
  textTransform: 'unset',

  [`&.${toggleButtonClasses.root}`]: {
    border: (theme) => `1px solid ${theme.customStyling.toggleButton.borderColor} !important`,
    margin: '0 !important',
    borderRadius: '.25rem',
    color: (theme) => theme.customStyling.toggleButton.color,

    [`&.${toggleButtonClasses.selected}`]: {
      borderColor: (theme) => `${theme.customStyling.toggleButton.selectedBorderColor} !important`,
      background: 'white',
      color: (theme) => theme.customStyling.toggleButton.selectedColor,
    },

    '&:disabled': {
      opacity: '0.5',

      [`.${checkboxClasses.root}`]: {
        opacity: '1',
      },

      [`.${radioClasses.root}`]: {
        opacity: '1',
      },
    },

    [`.${checkboxClasses.root}`]: {
      pointerEvents: 'none',
      padding: '0',
    },

    [`.${radioClasses.root}`]: {
      pointerEvents: 'none',
      fontSize: '1.5rem',
      padding: '0',
    },
  },
};

export const ToggleButtonWrapperStyle: StyleExtend<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '.5rem',
  width: '100%',
};

export const ToggleButtonLabelStyle: StyleExtend<Theme> = {
  flex: '1',
};

export const ToggleButtonDescriptionStyle: StyleExtend<Theme> = {
  maxWidth: '100%',
};
